// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7248":"1269b528","7395":"1269b528"}[chunkId] + ".chunk.css";
};